import React, { useState, useEffect } from "react";
import {
  Input,
  Collapse,
  Button,
  Alert,
  Label,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { deepClone } from "../../utils/copyObject";
import {
  maturity_model_questions_cats_wise,
  YES_NO_TYPE,
  WEEKS_TYPE,
} from "./data";
import { find, findIndex, filter } from "lodash";
import officeCreatedIcon from "../../assets/office_created_icon.svg";
import { IoCalendarClear } from "react-icons/io5";
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import * as url from "../../utils/url";
import axios from "../../axios";
import { toastContainer } from "../../utils/toast";
import { connect } from "react-redux";
import Loading from "../../hoc/Loading/Loading";
import * as actionCreators from "../../modules/actions";
import { isMobile } from "../../utils/deviceInfo";
import Select from "react-select/lib/Select";
import ExternalUserLoginSignup from "./Components/ExternalUserLoginSignup";
import MMInfoModal from "./Components/MMInfoModal";
import { formatDate } from "../../utils/constants";

function QuestionsTab({
  user,
  setPersistedState,
  persistedState,
  selectedDate,
  updateSelectedDate,
  isExternalUserLoggedIn,
  externalUserLoginDetails,
  updateExternalUserLogin,
}) {
  const [questionsListCatWise, setQuestionsListCatWise] = useState(
    deepClone(maturity_model_questions_cats_wise)
  );
  const [mmInfoModal, setMMInfoModal] = useState(false);
  const [collapse, setCollapse] = useState([]);
  const [originalStoredSurveys, setOriginalStoredSurveys] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [benchmarks, setBenchmarks] = useState([]);
  const [updatedQuestionsMap, setUpdatedQuestionsMap] = useState({});
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [loginDetails, setLoginDetails] = useState({
    email: "",
    password: "",
  });
  const [questionsLoading, setQuestionsLoading] = useState(false);
  const [responseChanged, setResponseChanged] = useState(true);
  const [lastSubmittedToShow, setLastSubmittedToShow] = useState(null);
  const [externalUserData, setExternaluserData] = useState({
    companyName: "",
    email: "",
    password: "",
    selectedBenchmarkId:null,
  });
  const [modalType, setModalType] = useState(1);
  const [scoreObj, setScoreObj] = useState(null);

  const isExternal = user && user.profile && user.profile._id ? false : true;

  useEffect(() => {
    if (isExternal) {
      if(!isExternalUserLoggedIn){
        setMMInfoModal(true)
      }
      axios.get(url.getMMBenchmarksData).then(({ data }) => {
        handleDateChange(selectedDate);

        setBenchmarks(
          data.data.map((x) => ({ label: x.industry, value: x._id }))
        );
      });
    } else {
      handleDateChange(selectedDate);
    }
  }, []);

  const getAnsweredCount = (i) => {
    const catObj = { ...questionsListCatWise[i] };

    const answered = catObj.questions.filter((x) => x.value);

    return answered.length;
  };

  const handleQuestionAnswered = (e, question, catIndex, qIndex) => {
    const mainArray = [...questionsListCatWise];

    const catObject = mainArray[catIndex];

    const questions = [...catObject.questions];

    const qObj = questions[qIndex];

    qObj.value = e.target.value;

    questions[qIndex] = qObj;

    mainArray[catIndex] = {
      ...mainArray[catIndex],
      questions: questions,
    };

    setQuestionsListCatWise(mainArray);
  };

  const isChecked = (catIndex, questionText, value) => {
    const docs = questionsListCatWise[catIndex].questions;

    const i = findIndex(docs, { text: questionText, value: value });
    if (i > -1) {
      return true;
    }
    return false;
  };

  const getValue = (catIndex, questionText) => {
    const docs = deepClone(questionsListCatWise[catIndex].questions);
    const question = find(docs, { text: questionText });
    if (question) {
      return question.value;
    }
    return "";
  };

  const onClear = (catIndex) => {
    const mainArray = [...questionsListCatWise];
    mainArray[catIndex] = {
      ...mainArray[catIndex],
      questions: mainArray[catIndex].questions.map((x) => ({
        ...x,
        value: "",
      })),
    };

    setQuestionsListCatWise(mainArray);
  };

  const handleSubmitQuestions = () => {
    const kpiSurveysData = questionsListCatWise.map((item) => {
      let score = 0;

      const maximumPossibleScore =
        item.questions.map((o) => o.score).reduce((a, b) => a + b) || 1;

      for (const itm of item.questions) {
        if (itm.optionsType === 1) {
          if (itm.value == "yes") {
            score += itm.score;
          }
        } else if (itm.optionsType === 3) {
          if (itm.value) {
            if (itm.value === "1-4 weeks") {
              score += 1;
            }
            if (itm.value === "5-8 weeks") {
              score += 2;
            }
            if (itm.value === ">8 weeks") {
              score += 3;
            }
            if (itm.value === "none") {
              score += 0;
            }
          }
        } else if (itm.optionsType === 2) {
          console.log("ival__", itm.value);
          if (itm.value) {
            score += parseInt(itm.value) / 100;
          }
        }
      }

      const scoreVal =
        maximumPossibleScore && score
          ? (score / maximumPossibleScore) * 100
          : 0;
      const officeObj =
        user &&
        user.profile &&
        user.profile.organizationId &&
        user.profile.organizationId.staticHierarchy &&
        Array.isArray(user.profile.organizationId.staticHierarchy)
          ? user.profile.organizationId.staticHierarchy.find(
              (x) => !x.parentNode
            ) || user.profile.organizationId.staticHierarchy[0]
          : null;

      if (isExternal) {
        return {
          kpiName: item.kpiId,
          organizationId: null,
          userId: null,
          type: item.type,
          group: item.group,
          timestamp: new Date(),
          kpiInputs: item.questions,
          score: scoreVal,
          selectedDate: selectedDate,
          isMM: true,
          updatedQuestions: item.questions || [],
          updatedDate: new Date(),
        };
      } else {
        return {
          kpiName: item.kpiId,
          organizationId: user.profile.organizationId,
          userId: user.profile._id,
          type: item.type,
          group: item.group,
          timestamp: new Date(),
          kpiInputs: item.questions,
          score: scoreVal,
          selectedDate: selectedDate,
          isMM: true,
          ...(officeObj && {
            officeKey: officeObj.officeKey,
          }),
          updatedQuestions: item.questions || [],
          updatedDate: new Date(),
        };
      }
    });

    const extData = {
      ...externalUserData,
      email:externalUserData.email.toLowerCase()
    }

    axios
      .post(
        isExternal
          ? url.handleSubmitMMQuestionsExternal
          : url.handleSubmitMMQuestions,
        { kpiSurveysData, externalUserData:extData, selectedDate, loginDetails }
      )
      .then(({ data }) => {
        if (isExternal) {
          // setQuestionsListCatWise(maturity_model_questions_cats_wise);
          // updateSelectedDate(null);
          setIsEdit(true);
          toastContainer(
            "Questions submitted successfully, Please check your email for the report!",
            "success"
          );
        } else {
          setLastSubmittedToShow(null);
          setOriginalStoredSurveys(deepClone(data.data));
          setResponseChanged(false);
          const questionsData = data.data.map((x) => {
            return {
              ...x,
              questions: x.kpiInputs,
              kpiInputs: null,
              kpiId: x.kpiName,
            };
          });

          if (!questionsData.length) {
            handlePopulateLastSurveyData(selectedDate);
            setIsEdit(false);
          } else {
            setIsEdit(true);
            setQuestionsListCatWise(questionsData);
          }
          handleTriggerScoreCalculation(data.data, false);
          toastContainer("Questions submitted successfully!", "success");
        }
      })
      .catch((err) => {
        toastContainer("Error while submitting questions", "error");
      });
  };

  useEffect(() => {
    setPersistedState({
      ...persistedState,
      questions: questionsListCatWise,
    });
  }, [questionsListCatWise]);

  useEffect(() => {
    setPersistedState({
      ...persistedState,
      selectedDate: selectedDate,
    });
  }, [selectedDate]);

  useEffect(() => {
    if (
      externalUserLoginDetails &&
      externalUserLoginDetails.email &&
      externalUserLoginDetails.password
    ) {
      setLoginDetails(externalUserLoginDetails);
    } else {
      setLoginDetails({
        email: "",
        password: "",
      });
    }
  }, [externalUserLoginDetails]);

  const handlePopulateLastSurveyData = (date) => {
    // setQuestionsListCatWise(deepClone(maturity_model_questions_cats_wise))
    if (
      isExternal &&
      isExternalUserLoggedIn &&
      externalUserLoginDetails.email &&
      externalUserLoginDetails.password
    ) {
      axios
        .post(url.getExternalUserMMScores, {
          selectedDate: null,
          showDataBeforeDate: date,
          email: externalUserLoginDetails.email,
          password: externalUserLoginDetails.password,
        })
        .then(({ data }) => {
          if (data.data.score) {
            setScoreObj(data.data.score);
          }
          // setOriginalStoredSurveys(deepClone(data.data));
          setResponseChanged(true);
          const questionsData = data.data.data.map((x) => {
            return {
              questions: x.kpiInputs.map((y) => ({
                text: y.text,
                value: y.value,
              })),
              kpiInputs: null,
              kpiId: x.kpiName,
              updatedDate: x.updatedDate,
              selectedDate: x.selectedDate,
            };
          });

          if (!questionsData.length) {
            setMMInfoModal(true)
            setQuestionsListCatWise(
              deepClone(maturity_model_questions_cats_wise)
            );
          } else {
            const newData = deepClone(maturity_model_questions_cats_wise).map(
              (item) => {
                const kpiObjectOld = questionsData.find(
                  (c) => c.kpiId == item.kpiId
                );
                const kpiObjectNewQuestions = item.questions.map((question) => {
                  const value = kpiObjectOld.questions.find(
                    (x) => x.text == question.text
                  )
                    ? kpiObjectOld.questions.find(
                        (x) => x.text == question.text
                      ).value
                    : "";
                  return {
                    ...question,
                    value: value,
                  };
                });

                return {
                  ...item,
                  updatedDate: kpiObjectOld.updatedDate,
                  selectedDate: kpiObjectOld.selectedDate,
                  questions: kpiObjectNewQuestions,
                };
              }
            );

            setLastSubmittedToShow(newData[0].selectedDate);
            //  alert(JSON.stringify(newData[0]))
            setQuestionsListCatWise(newData);
          }
        })
        .catch((err) => {
          setQuestionsLoading(false);
        });
    } else {
      axios
        .post(url.getMMQuestionsByDate, {
          selectedDate: null,
          showDataBeforeDate: date,
        })
        .then(({ data }) => {
          // setOriginalStoredSurveys(deepClone(data.data));
          setResponseChanged(true);
          const questionsData = data.data.map((x) => {
            return {
              questions: x.kpiInputs.map((y) => ({
                text: y.text,
                value: y.value,
              })),
              kpiInputs: null,
              kpiId: x.kpiName,
              updatedDate: x.updatedDate,
              selectedDate: x.selectedDate,
            };
          });

          if (!questionsData.length) {
            setQuestionsListCatWise(
              deepClone(maturity_model_questions_cats_wise)
            );
          } else {
            const newData = deepClone(maturity_model_questions_cats_wise).map(
              (item) => {
                const kpiObjectOld = questionsData.find(
                  (c) => c.kpiId == item.kpiId
                );
                const kpiObjectNewQuestions = item.questions.map((question) => {
                  const value = kpiObjectOld.questions.find(
                    (x) => x.text == question.text
                  )
                    ? kpiObjectOld.questions.find(
                        (x) => x.text == question.text
                      ).value
                    : "";
                  return {
                    ...question,
                    value: value,
                  };
                });

                return {
                  ...item,
                  updatedDate: kpiObjectOld.updatedDate,
                  selectedDate: kpiObjectOld.selectedDate,
                  questions: kpiObjectNewQuestions,
                };
              }
            );

            setLastSubmittedToShow(newData[0].selectedDate);
            //  alert(JSON.stringify(newData[0]))
            setQuestionsListCatWise(newData);
          }
        })
        .catch((err) => {
          setQuestionsLoading(false);
        });
    }
  };

  const handleDateChange = (d) => {
    if (
      isExternal &&
      isExternalUserLoggedIn &&
      externalUserLoginDetails.email &&
      externalUserLoginDetails.password
    ) {
      setQuestionsLoading(true);
      if (d) {
        updateSelectedDate(formatDate(d));
        axios
          .post(url.getExternalUserMMScores, {
            selectedDate: formatDate(d),
            email: externalUserLoginDetails.email,
            password: externalUserLoginDetails.password,
          })
          .then(({ data }) => {
            if (data.data.score) {
              setScoreObj(data.data.score);
            }
            setLastSubmittedToShow(null);
            setQuestionsLoading(false);
            setOriginalStoredSurveys(deepClone(data.data.data));
            setResponseChanged(false);
            const questionsData = data.data.data.map((x) => {
              return {
                ...x,
                questions: x.kpiInputs,
                kpiInputs: null,
                kpiId: x.kpiName,
              };
            });

            if (!questionsData.length) {
              setIsEdit(false);
              handlePopulateLastSurveyData(formatDate(d));
            } else {
              setIsEdit(true);
              setQuestionsListCatWise(questionsData);
            }
          })
          .catch((err) => {
            setQuestionsLoading(false);
          });
      } else {
        axios
          .post(url.getExternalUserMMScores, {
            selectedDate: formatDate(d),
            email: externalUserLoginDetails.email,
            password: externalUserLoginDetails.password,
          })
          .then(({ data }) => {
            setLastSubmittedToShow(null);
            setQuestionsLoading(false);
            setOriginalStoredSurveys(deepClone(data.data.data));
            setResponseChanged(false);
            const questionsData = data.data.data.map((x) => {
              return {
                ...x,
                questions: x.kpiInputs,
                kpiInputs: null,
                kpiId: x.kpiName,
              };
            });

            if (!questionsData.length) {
              setIsEdit(false);
              handlePopulateLastSurveyData(formatDate(d));
            } else {
              updateSelectedDate(questionsData[0].selectedDate);
              setIsEdit(true);
              setQuestionsListCatWise(questionsData);
            }
          })
          .catch((err) => {
            setQuestionsLoading(false);
          });
      }
    } else {
      setQuestionsLoading(true);
      if (d) {
        updateSelectedDate(formatDate(d));
        axios
          .post(url.getMMQuestionsByDate, {
            selectedDate: formatDate(d),
          })
          .then(({ data }) => {
            setLastSubmittedToShow(null);
            setQuestionsLoading(false);
            setOriginalStoredSurveys(deepClone(data.data));
            setResponseChanged(false);
            const questionsData = data.data.map((x) => {
              return {
                ...x,
                questions: x.kpiInputs,
                kpiInputs: null,
                kpiId: x.kpiName,
              };
            });

            if (!questionsData.length) {
              setIsEdit(false);
              handlePopulateLastSurveyData(formatDate(d));
            } else {
              setIsEdit(true);
              setQuestionsListCatWise(questionsData);
            }
          })
          .catch((err) => {
            setQuestionsLoading(false);
          });
      } else {
        axios
          .post(url.getMMQuestionsByDate, {
            selectedDate: formatDate(d),
          })
          .then(({ data }) => {
            setLastSubmittedToShow(null);
            setQuestionsLoading(false);
            setOriginalStoredSurveys(deepClone(data.data));
            setResponseChanged(false);
            const questionsData = data.data.map((x) => {
              return {
                ...x,
                questions: x.kpiInputs,
                kpiInputs: null,
                kpiId: x.kpiName,
              };
            });

            if (!questionsData.length) {
              setIsEdit(false);
              handlePopulateLastSurveyData(formatDate(d));
            } else {
              updateSelectedDate(questionsData[0].selectedDate);
              setIsEdit(true);
              setQuestionsListCatWise(questionsData);
            }
          })
          .catch((err) => {
            setQuestionsLoading(false);
          });
      }
    }
  };

  const handleTriggerScoreCalculation = (data, edit) => {
    axios
      .post(url.triggerScoreCalculation, {
        savedData: data,
        selectedDate,
        isEdit: edit,
      })
      .then(({ data }) => {
        console.log("ScoreObject", data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSubmitQuestionsEditMode = () => {
    const kpiSurveysData = questionsListCatWise.map((item) => {
      let score = 0;

      const maximumPossibleScore =
        item.questions.map((o) => o.score).reduce((a, b) => a + b) || 1;

      for (const itm of item.questions) {
        if (itm.optionsType === 1) {
          if (itm.value == "yes") {
            score += itm.score;
          }
        } else if (itm.optionsType === 3) {
          if (itm.value) {
            if (itm.value === "1-4 weeks") {
              score += 1;
            }
            if (itm.value === "5-8 weeks") {
              score += 2;
            }
            if (itm.value === ">8 weeks") {
              score += 3;
            }
            if (itm.value === "none") {
              score += 0;
            }
          }
        } else if (itm.optionsType === 2) {
          console.log("ival__", itm.value);
          if (itm.value) {
            score += parseInt(itm.value) / 100;
          }
        }
      }

      const scoreVal =
        maximumPossibleScore && score
          ? (score / maximumPossibleScore) * 100
          : 0;

      const officeObj =
        user.profile.organizationId.staticHierarchy &&
        Array.isArray(user.profile.organizationId.staticHierarchy)
          ? user.profile.organizationId.staticHierarchy.find(
              (x) => !x.parentNode
            ) || user.profile.organizationId.staticHierarchy[0]
          : null;
      return {
        _id: item._id,
        kpiName: item.kpiId,
        organizationId: user.profile.organizationId,
        userId: user.profile._id,
        type: item.type,
        group: item.group,
        kpiInputs: item.questions.map((x) => ({
          ...x,
          updatedDate: new Date(),
        })),
        score: scoreVal,
        selectedDate: item.selectedDate,
        updatedDate: new Date(),
        isMM: true,
        ...(officeObj && {
          officeKey: officeObj.officeKey,
        }),
        updatedQuestions: updatedQuestionsMap[item.kpiId] || [],
        timestamp:new Date()
      };
    });

    axios
      .post(url.handleEditSubmitMMQuestions, { kpiSurveysData })
      .then(({ data }) => {
        setLastSubmittedToShow(null);
        setOriginalStoredSurveys(deepClone(data.data));
        setResponseChanged(false);
        const questionsData = data.data.map((x) => {
          return {
            ...x,
            questions: x.kpiInputs,
            kpiInputs: null,
            kpiId: x.kpiName,
          };
        });

        if (!questionsData.length) {
          handlePopulateLastSurveyData(selectedDate);
          setIsEdit(false);
        } else {
          setIsEdit(true);
          setQuestionsListCatWise(questionsData);
        }
        handleTriggerScoreCalculation(data.data, true);
        toastContainer("Questions submitted successfully!", "success");
      })
      .catch((err) => {
        toastContainer("Error while submitting questions", "error");
      });
  };
 

  useEffect(() => {
    for (const item of questionsListCatWise) {
      const questions = item.questions;
      const orgnlQuestions = originalStoredSurveys.find(x => x._id == item._id)

      if(orgnlQuestions){
        const orgnlQueArray = orgnlQuestions.kpiInputs;
        for (let index = 0; index < questions.length; index++) {
          const element = questions[index];
          if(item.kpiName=="PRP-1"){
           console.log("uiuiuiiuiuiuiu",element.value,orgnlQueArray[index].value)
          }
        
          if(orgnlQueArray[index]){
           if(element.value != orgnlQueArray[index].value){
            handleUpdatedQuestionsMap(element,item.kpiId)
             setResponseChanged(true)
           }else{
             
           }
          }
        }
      }
   }

 
  }, [questionsListCatWise])
  

  

  const handleUpdatedQuestionsMap = (question, kpi) => {
    const mapObj = { ...updatedQuestionsMap };

    if (mapObj[kpi] && Array.isArray(mapObj[kpi])) {
      mapObj[kpi].push(question);
    } else {
      mapObj[kpi] = [question];
    }

    setUpdatedQuestionsMap(mapObj);
  };

  useEffect(() => {
    for (const item of questionsListCatWise) {
      const questions = item.questions;
      const orgnlQuestions = originalStoredSurveys.find(
        (x) => x._id == item._id
      );

      if (orgnlQuestions) {
        const orgnlQueArray = orgnlQuestions.kpiInputs;
        for (let index = 0; index < questions.length; index++) {
          const element = questions[index];
          if (item.kpiName == "PRP-1") {
            console.log(
              "uiuiuiiuiuiuiu",
              element.value,
              orgnlQueArray[index].value
            );
          }

          if (orgnlQueArray[index]) {
            if (element.value != orgnlQueArray[index].value) {
              handleUpdatedQuestionsMap(element, item.kpiId);
              setResponseChanged(true);
            } else {
            }
          }
        }
      }
    }
  }, [questionsListCatWise]);

  const handleCollapsePush = (i) => {
    const collapseArr = [...collapse];
    if (collapseArr.includes(i)) {
      const newArr = collapseArr.filter((x) => x != i);
      setCollapse(newArr);
    } else {
      collapseArr.push(i);
      setCollapse(collapseArr);
    }
  };

  useEffect(() => {
    if (isExternalUserLoggedIn) {
      handleDateChange(selectedDate);
    }
  }, [isExternalUserLoggedIn]);

  const handleLogin = () => {
    axios
      .post(url.handleMMExternalUserLogin, {
        email: loginDetails.email,
        password: loginDetails.password,
      })
      .then(({ data }) => {
        setLoginModalOpen(false);
        if (data.data.loginSuccess) {
          updateExternalUserLogin({
            isExternalUserLoggedIn: true,
            externalUserLoginDetails: {
              email: loginDetails.email,
              password: loginDetails.password,
              ...(data.data.userData && {
                companyName:data.data.userData.companyName,
                industry:data.data.userData.indusry
              })
             
            },
          });
        } else {
          toastContainer("Please enter correct credentials", "error");
        }
      })
      .catch((err) => {
        toastContainer("Error while login", "error");
      });
  };

  const handleLogout = () => {
    updateExternalUserLogin({
      isExternalUserLoggedIn: false,
      externalUserLoginDetails: {
        email: "",
        password: "",
        companyName:"",
        industry:""
      },
    });
    updateSelectedDate(formatDate(new Date()));
    setQuestionsListCatWise(deepClone(maturity_model_questions_cats_wise));
    setIsEdit(false);
    setResponseChanged(false);
    setOriginalStoredSurveys([]);
  };

  const handleEditSubmissionForExternalUser = () => {
    const scoreObjOriginal = scoreObj;

    const kpiSurveysData = questionsListCatWise.map((item) => {
      let score = 0;

      const maximumPossibleScore =
        item.questions.map((o) => o.score).reduce((a, b) => a + b) || 1;

      for (const itm of item.questions) {
        if (itm.optionsType === 1) {
          if (itm.value == "yes") {
            score += itm.score;
          }
        } else if (itm.optionsType === 3) {
          if (itm.value) {
            if (itm.value === "1-4 weeks") {
              score += 1;
            }
            if (itm.value === "5-8 weeks") {
              score += 2;
            }
            if (itm.value === ">8 weeks") {
              score += 3;
            }
            if (itm.value === "none") {
              score += 0;
            }
          }
        } else if (itm.optionsType === 2) {
          console.log("ival__", itm.value);
          if (itm.value) {
            score += parseInt(itm.value) / 100;
          }
        }
      }

      const scoreVal =
        maximumPossibleScore && score
          ? (score / maximumPossibleScore) * 100
          : 0;
      return {
        kpiName: item.kpiId,
        organizationId: null,
        userId: null,
        type: item.type,
        group: item.group,
        timestamp: new Date(),
        kpiInputs: item.questions,
        score: scoreVal,
        selectedDate: selectedDate,
        isMM: true,
        // updatedQuestions: item.questions || [],
        updatedDate: new Date(),
      };
    });

    axios
      .post(url.updateQuestionsForExternalUserScoreObject, {
        kpiSurveysData,
        reportId: scoreObjOriginal._id,
      })
      .then(({ data }) => {
        toastContainer("Changes updated successfully!", "success");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className="mm_questions_container pt-3">
      {mmInfoModal && (
        <MMInfoModal
          open={mmInfoModal}
          onClose={() => {
            setMMInfoModal(false);
          }}
        />
      )}
      <div className="d-flex justify-content-center">
        <Alert
          color={selectedDate ? "success" : "info"}
          className="mb-0"
          style={{
            width: "60%",
            backgroundColor: "#a3bfe940",
            color: "#172b4d",
            borderColor: "#a3bfe940",
            marginBottom: "0px",
            padding: "0.35em 0.5em",
          }}
        >
          <div className="d-flex align-items-center">
            {selectedDate ? (
              <b> Data as of</b>
            ) : (
              <b> Please first select a date to continue</b>
            )}{" "}
            <div style={{ flex: 1 }}>
              <ReactDatePicker
                id="selectFileDate"
                showIcon={true}
                placeholderText="Enter date"
                className="input-custom-date input-date-mm form-control ml-3"
                showYearDropdown
                onChange={(d) => {
                  handleDateChange(d);
                }}
                maxDate={moment()
                  .endOf("day")
                  }
                // customInput={
                //   selectedDate?
                //   <span>
                //     {moment(selectedDate).format("MMMM D, YYYY")}
                //   </span>
                //   :
                //   undefined
                // }
                selected={selectedDate ? moment(selectedDate) : null}
                // icon={<IoCalendarClear />}
              />
              <IoCalendarClear
                size={22}
                className="calendar-icon"
                style={{
                  position: "absolute",
                  right: "30px",
                  top: "40%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (document.getElementById("selectFileDate")) {
                    document.getElementById("selectFileDate").click();
                  }
                }}
              />
            </div>
          </div>
        </Alert>

        {isExternal && (
          <div className="ml-5 py-3">
            {isExternalUserLoggedIn ? (
              <span>
                Logged in as <b>{externalUserLoginDetails.email}</b>{" "}
                <span
                  onClick={() => {
                    handleLogout();
                  }}
                  className="link-text"
                >
                  (Logout)
                </span>{" "}
              </span>
            ) : (
              <span
                onClick={() => {
                  setLoginModalOpen(true);
                  setModalType(1);
                }}
                className="link-text"
              >
                Log in ?
              </span>
            )}

            {loginModalOpen ? (
              <ExternalUserLoginSignup
                modalType={modalType}
                setModalType={setModalType}
                loginDetails={loginDetails}
                setLoginDetails={setLoginDetails}
                setLoginModalOpen={setLoginModalOpen}
                externalUserData={externalUserData}
                setExternaluserData={setExternaluserData}
                benchmarks={benchmarks}
                handleProceed={(type) => {
                  if (type == "login") {
                    handleLogin();
                  }
                  if (type == "register") {
                    handleSubmitQuestions();
                  }
                }}
              />
            ) : (
              ""
            )}
          </div>
        )}
      </div>

      <div className="mb-4 text-center mm-snapshot-last-update-itm">
        {lastSubmittedToShow ? (
          <span>
            Last updated: {moment(lastSubmittedToShow).format("MM/DD/YYYY")}
          </span>
        ) : (
          ""
        )}
      </div>

      {questionsLoading ? (
        <div className="text-center mt-4">
          <h4>Checking for past Workplace Assessment data...</h4>
        </div>
      ) : (
        <div>
          <div
            className={
              selectedDate
                ? "mm_questions_container_q defaultPadding"
                : "disabled mm_questions_container_q defaultPadding"
            }
          >
            {questionsListCatWise.map((category, i) => {
              return (
                <div key={i}>
                  <div
                    className="row cursor-pointer"
                    onClick={() => handleCollapsePush(i)}
                    key={i}
                  >
                    <div className="questions-row-title col-md-6 col-lg-6">
                      {category.type}
                    </div>
                    <div className="questions-row-help-text col-md-5 col-lg-5">
                      {getAnsweredCount(i) === category.questions.length ? (
                        <div className="complete">
                          <span style={{ marginRight: "10px" }}>
                            <img src={officeCreatedIcon} />
                          </span>
                          <span>
                            ({getAnsweredCount(i)} of{" "}
                            {category.questions.length} questions answered)
                          </span>
                        </div>
                      ) : (
                        <div>
                          ({getAnsweredCount(i)} of {category.questions.length}{" "}
                          questions answered)
                        </div>
                      )}
                    </div>
                    <div
                      className={
                        "col-lg-1 col-md-1 " +
                        (collapse === i ? "rotate-arrow" : "text-center")
                      }
                    >
                      <i className="flaticon-down-arrow review-flaticon-down-arrow cursor-pointer"></i>
                    </div>
                  </div>
                  <Collapse isOpen={collapse.includes(i)}>
                    <div>
                      {category.questions.map((question, j) => {
                        return (
                          <div key={j}>
                            <div className="mt30 question-text">
                              {question.text}
                            </div>
                            {question.optionsType === YES_NO_TYPE ? (
                              <div
                                onChange={(e) => {
                                  handleQuestionAnswered(e, question, i, j);
                                }}
                              >
                                <div className={`radio`}>
                                  <input
                                    id={`radio-${i}-${j}-1`}
                                    name={`radio-${i}-${j}`}
                                    type="radio"
                                    value="yes"
                                    checked={isChecked(i, question.text, "yes")}
                                  />
                                  <label
                                    htmlFor={`radio-${i}-${j}-1`}
                                    className="radio-label custom-radio-labels"
                                  >
                                    Yes
                                  </label>
                                </div>
                                <div className="radio">
                                  <input
                                    id={`radio-${i}-${j}-2`}
                                    name={`radio-${i}-${j}`}
                                    type="radio"
                                    value="no"
                                    checked={isChecked(i, question.text, "no")}
                                  />
                                  <label
                                    htmlFor={`radio-${i}-${j}-2`}
                                    className="radio-label custom-radio-labels"
                                  >
                                    No
                                  </label>
                                </div>
                              </div>
                            ) : question.optionsType === WEEKS_TYPE ? (
                              <div
                                onChange={(e) => {
                                  handleQuestionAnswered(e, question, i, j);
                                }}
                              >
                                <div className={`radio`}>
                                  <input
                                    id={`radio-${i}-${j}-1`}
                                    name={`radio-${i}-${j}`}
                                    type="radio"
                                    value="none"
                                    checked={isChecked(
                                      i,
                                      question.text,
                                      "none"
                                    )}
                                  />
                                  <label
                                    htmlFor={`radio-${i}-${j}-1`}
                                    className="radio-label custom-radio-labels"
                                  >
                                    None
                                  </label>
                                </div>
                                <div className="radio">
                                  <input
                                    id={`radio-${i}-${j}-2`}
                                    name={`radio-${i}-${j}`}
                                    type="radio"
                                    value="1-4 weeks"
                                    checked={isChecked(
                                      i,
                                      question.text,
                                      "1-4 weeks"
                                    )}
                                  />
                                  <label
                                    htmlFor={`radio-${i}-${j}-2`}
                                    className="radio-label custom-radio-labels"
                                  >
                                    1-4 weeks
                                  </label>
                                </div>
                                <div className="radio">
                                  <input
                                    id={`radio-${i}-${j}-3`}
                                    name={`radio-${i}-${j}`}
                                    type="radio"
                                    value="5-8 weeks"
                                    checked={isChecked(
                                      i,
                                      question.text,
                                      "5-8 weeks"
                                    )}
                                  />
                                  <label
                                    htmlFor={`radio-${i}-${j}-3`}
                                    className="radio-label custom-radio-labels"
                                  >
                                    5-8 weeks
                                  </label>
                                </div>
                                <div className="radio">
                                  <input
                                    id={`radio-${i}-${j}-4`}
                                    name={`radio-${i}-${j}`}
                                    type="radio"
                                    value=">8 weeks"
                                    checked={isChecked(
                                      i,
                                      question.text,
                                      ">8 weeks"
                                    )}
                                  />
                                  <label
                                    htmlFor={`radio-${i}-${j}-4`}
                                    className="radio-label custom-radio-labels"
                                  >
                                    {">"}8 weeks
                                  </label>
                                </div>
                              </div>
                            ) : (
                              <div
                                className="mt10"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Input
                                  type="text"
                                  style={{ width: "25%" }}
                                  placeholder="Enter %"
                                  onChange={(e) => {
                                    handleQuestionAnswered(e, question, i, j);
                                  }}
                                  value={getValue(i, question.text)}
                                />
                                <span className="ml5">%</span>
                              </div>
                            )}
                          </div>
                        );
                      })}
                      <div className="question-clear mt30 mb10 cursor-pointer">
                        <span onClick={() => onClear(i)}>Clear</span>
                      </div>
                    </div>
                  </Collapse>
                  <hr style={{ marginTop: "20px", marginBottom: "20px" }} />
                </div>
              );
            })}
          </div>

          <div className="questions_submit_btn_div defaultPadding">
{isExternal ? (
            <div className="">
              {isExternalUserLoggedIn && isEdit && scoreObj && scoreObj._id ? (
                <div>You have submitted questions for this date already.</div>
              ) : (
                // <Button
                //   color="primary"
                //   onClick={() => {
                //     handleEditSubmissionForExternalUser();
                //   }}
                // >
                //   Edit
                // </Button>
                <Button
                  className="submit_questions_button"
                  color="primary"
                  onClick={() => {
                    if (isExternalUserLoggedIn) {
                      handleSubmitQuestions();
                    } else {
                      setLoginModalOpen(true);
                      setModalType(2);
                    }
                  }}
                >
                  Submit
                </Button>
              )}
            </div>
          ) : (
            <div>
              {isEdit ? (
                <div className="mt-2">
                  <Button
                  className="submit_questions_button2"
                    disabled={!responseChanged}
                    color="primary"
                    onClick={handleSubmitQuestionsEditMode}
                  >
                    Submit again
                  </Button>
                </div>
              ) : (
                <div className="mt-2">
                  <Button color="primary" className="submit_questions_button" onClick={handleSubmitQuestions}>
                    Submit
                  </Button>
                </div>
              )}
            </div>
          )}
          </div>

          
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    selectedDate: state.maturityModel.selectedDate,
    isExternalUserLoggedIn: state.maturityModel.isExternalUserLoggedIn,
    externalUserLoginDetails: state.maturityModel.externalUserLoginDetails,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateSelectedDate: (data) =>
      dispatch(actionCreators.updateSelectedDate(data)),
    updateExternalUserLogin: (data) =>
      dispatch(actionCreators.updateExternalUserLogin(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(
  QuestionsTab,
  axios
);
